export default "__VITE_ASSET__895a17cb__"